import gvt_logo from "./UPGovLatestLogo.png";
import kumbhMela from "./kumbh_mela_img.png";

export const IMAGELIST = {
  govt_logo: gvt_logo,
  kumbhMela: kumbhMela,
};
